import React from 'react';
import { CssBaseline } from '@mui/material';
import ReactDOM from "react-dom/client";
import NavigationSetup from './utils/NavigationSetup';

import App from './App';
import ContextProvider from './ContextProvider';
import { createBrowserHistory } from 'history';
import mainTheme, { GlobalStyle } from './utils/styles';
import typography from './utils/typography';

import '@fontsource/montserrat/latin-100.css';
import '@fontsource/montserrat/latin-200.css';
import '@fontsource/montserrat/latin-300.css';
import '@fontsource/montserrat/latin-400.css';
import '@fontsource/montserrat/latin-500.css';
import '@fontsource/montserrat/latin-600.css';
import '@fontsource/montserrat/latin-700.css';
import '@fontsource/montserrat/latin-800.css';
import '@fontsource/montserrat/latin-900.css';

typography.injectStyles();

const history = createBrowserHistory();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <ContextProvider theme={mainTheme}>
    <NavigationSetup />
    <App history={history}/>
    <CssBaseline />
    <GlobalStyle />
  </ContextProvider>
);
